export class DateHelpers {
  /**
   * formatTime takes a date and returns a fomatted string, for example 12:34PM
   */
  static formatTime = (date: Date) => {
    let hours = date.getHours();
    const meridiemString = hours > 11 ? 'PM' : 'AM';
    if (meridiemString === 'PM' && hours !== 12) {
      hours -= 12;
    }
    return `${hours}:${date.getMinutes()}${meridiemString}`;
  };

  private static formatDayOrMonth = (num: number) => {
    if (num < 10) {
      return '0' + num.toString();
    }
    return num.toString();
  };

  /**
   * formatMonth takes a number representing the month and returns a two digit string, for example 9 => "09"
   */
  static formatMonth = (month: number) => DateHelpers.formatDayOrMonth(month);

  /**
   * formatDay takes a number representing the day and returns a two digit string, for example 9 => "09"
   */
  static formatDay = (day: number) => DateHelpers.formatDayOrMonth(day);

  /**
   * formatDate takes a Date or string representing the date and returns a user-friendly string, for example
   * Mon Mar 28 2022 07:27:13 GMT+0100 (British Summer Time) => 28/03, 07:27AM
   */
  static formatDate = (date: Date | string) => {
    let unformattedDate: Date = date as Date;
    if (typeof date === 'string') {
      unformattedDate = new Date(date);
    }
    return `${DateHelpers.formatDay(unformattedDate.getDay())}/${DateHelpers.formatMonth(
      unformattedDate.getMonth(),
    )}, ${DateHelpers.formatTime(unformattedDate)}`;
  };

  /**
   *
   * @param isoDateString
   * @returns "12 April"
   */
  static formatDateDayMonth(isoDateString: Date | string) {
    if (!Boolean(isoDateString)) return false;

    let date: Date = isoDateString as Date;

    if (typeof isoDateString === 'string') {
      date = new Date(isoDateString);
    }

    // Create an Intl.DateTimeFormat object to format the date
    const formatter = new Intl.DateTimeFormat('en-us', {
      day: 'numeric',
      month: 'long',
    });

    // Format the date according to the specified options
    return formatter.format(date).split(' ').reverse().join(' ');
  }
  /**
   *
   * @param isoDateString
   * @returns "Monday 30th December 2024"
   */
  static formatDateVerbose(isoDateString: Date | string) {
    if (!isoDateString) return false;

    let date: Date = isoDateString as Date;

    if (typeof isoDateString === 'string') {
      date = new Date(isoDateString);
    }

    const day = date.toLocaleDateString('en-GB', { weekday: 'long' });
    const dayNumber = date.getDate();
    const month = date.toLocaleDateString('en-GB', { month: 'long' });
    const year = date.getFullYear();

    // Get the suffix for the day (1st, 2nd, 3rd, etc.)
    const suffix = (() => {
      if (dayNumber >= 11 && dayNumber <= 13) return 'th';
      switch (dayNumber % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    })();

    return `${day} ${dayNumber}${suffix} ${month} ${year}`;
  }

  static addMonths = (date: Date, months: number) => {
    var result = date;

    if (months > 0) {
      result.setMonth(result.getDate() + months);
    }
    return result;
  };

  static daysBetween = (startDate: Date, endDate: Date) => {
    return Math.floor(endDate.getTime() - startDate.getTime()) / 86400000;
  };
}
